import { Typography } from '@mui/material';
import theme3 from 'assets/scss/_theme3.module.scss';

const getPriorityChipByType = (priority, returnComponent = true) => {
    let priorityText;
    let textColor;
    let bgColor;

    switch (priority) {
        case 4:
            priorityText = 'Critical';
            textColor = theme3.orangeDark;
            bgColor = theme3.orangeLight;
            break;
        case 3:
            priorityText = 'High';
            textColor = '#FF7300';
            bgColor = '#FFEBDA';
            break;
        case 2:
            priorityText = 'Medium';
            textColor = theme3.warningDark;
            bgColor = theme3.warningLight;
            break;
        case 1:
            priorityText = 'Low';
            textColor = theme3.successDark;
            bgColor = theme3.successLight;
            break;
        default:
            priorityText = '';
            textColor = 'black';
            bgColor = 'white';
    }

    if (returnComponent) {
        return (
            <Typography
                variant="subtitle2"
                sx={{
                    color: textColor,
                    bgcolor: bgColor,
                    padding: '4px 12px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    fontSize: 14,
                    textAlign: 'center'
                }}
            >
                {priorityText}
            </Typography>
        );
    }

    return {
        text: priorityText,
        color: textColor,
        bgColor
    };
};

export default getPriorityChipByType;
